import { ic, lc } from '../helpers';
import { STORAGE_OPTIONS } from '../constants';

// ─────────────────────────────────────────
// VALUABLES FOLLOW-UP BLOCK
// Renders 3 quick questions used to derive PURE's yellow follow-up
// fields (HVI, Blanket Single Article Limit, Item Description,
// Appraised radio, Home Safe radio).
//
// We ask the smallest set the client actually knows the answer to:
//   1. Value of their most valuable single piece (HVI)
//   2. Whether it's been appraised in the last 2 years (real discount)
//   3. Where it's kept (drives home-safe / bank-vault decisions)
//
// Everything else PURE asks (BSAL, descriptions, secondary radios)
// is defaulted by the filler — we never ask the client.
// ─────────────────────────────────────────
export default function ValuablesDetails({ category, liability, setLiability }) {
  const hviKey       = `${category}HVI`;
  const appraisedKey = `${category}Appraised`;
  const storageKey   = `${category}Storage`;

  return (
    <div className="mt-3 pt-3 border-t border-slate-200 space-y-3">
      {/* HVI */}
      <div>
        <label className={lc}>Value of your most valuable single piece ($)</label>
        <input
          type="number"
          min="0"
          value={liability[hviKey] ?? ''}
          onChange={e => setLiability(p => ({ ...p, [hviKey]: e.target.value }))}
          placeholder="e.g. 25000"
          className={ic}
        />
      </div>

      {/* Appraised */}
      <div>
        <label className={lc}>
          Has it been appraised in the last 2 years?
          <span className="block text-xs font-normal text-slate-500 mt-0.5">
            A discount may be applied if yes.
          </span>
        </label>
        <div className="flex gap-2">
          {[
            { v: true,  l: 'Yes' },
            { v: false, l: 'No'  },
          ].map(opt => (
            <button
              key={opt.l}
              type="button"
              onClick={() => setLiability(p => ({ ...p, [appraisedKey]: opt.v }))}
              className={`flex-1 py-2 rounded-xl text-xs font-semibold border-2 transition ${
                liability[appraisedKey] === opt.v
                  ? 'border-blue-500 bg-blue-50 text-blue-700'
                  : 'border-slate-200 text-slate-600 hover:bg-slate-50'
              }`}
            >
              {opt.l}
            </button>
          ))}
        </div>
      </div>

      {/* Storage */}
      <div>
        <label className={lc}>Where do you keep it?</label>
        <div className="grid grid-cols-2 gap-2">
          {STORAGE_OPTIONS.map(opt => (
            <button
              key={opt.v}
              type="button"
              onClick={() => setLiability(p => ({ ...p, [storageKey]: opt.v }))}
              className={`py-2 rounded-xl text-xs font-semibold border-2 transition ${
                liability[storageKey] === opt.v
                  ? 'border-blue-500 bg-blue-50 text-blue-700'
                  : 'border-slate-200 text-slate-600 hover:bg-slate-50'
              }`}
            >
              {opt.l}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}